<div
  class="color-primary grab-mask order-form-field-form-container"
  [formGroup]="orderFormFieldGroup"
>
  <div class="options">
    <mat-checkbox color="primary" [formControlName]="'requiredControl'">
      {{ 'FRONTEND.STORE.REQUIRED' | translate }}
    </mat-checkbox>
    <mat-checkbox
      color="primary"
      [formControlName]="'forOfficeUseOnly'"
      [disabled]="orderFormFieldGroup.get('officeEditableOnly').value"
      [matTooltip]="
        'FRONTEND.STORE.ORDER_FORM.FOR_OFFICE_USE_ONLY_TOOLTIP' | translate
      "
    >
      <span class="underlined">
        {{ 'FRONTEND.STORE.ORDER_FORM.HIDDEN_FROM_END_USERS' | translate }}
      </span>
    </mat-checkbox>
    <mat-checkbox
      color="primary"
      [formControlName]="'officeEditableOnly'"
      [disabled]="orderFormFieldGroup.get('forOfficeUseOnly').value"
      [matTooltip]="
        'FRONTEND.STORE.ORDER_FORM.OFFICE_EDITABLE_ONLY_TOOLTIP' | translate
      "
    >
      <span class="underlined">
        {{ 'FRONTEND.STORE.ORDER_FORM.OFFICE_EDITABLE_ONLY' | translate }}
      </span>
    </mat-checkbox>
  </div>
  <mat-form-field class="order-form-mat-form-field">
    <mat-select
      matInput
      formControlName="typeControl"
      placeholder="Type"
      required
      novalidate
    >
      <mat-option *ngFor="let field of supportedFieldTypes" [value]="field">
        {{ field.name | translate }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="'typeControl.invalid'">
      {{ 'FRONTEND.STORE.ORDER_FORM.FIELD_TYPE_REQUIRED' | translate }}
    </mat-error>
  </mat-form-field>
  <!-- Options if drop down type is selected -->
  <ng-container
    *ngIf="
      getCurrentFieldInterface() && getCurrentFieldInterface() === 'dropdown'
    "
  >
    <div
      formArrayName="optionsFormArray"
      *ngFor="let option of getOptionsArray().controls; let i = index"
    >
      <div class="removable-form-field dropdown-option">
        <mat-form-field class="dropdown-option-label">
          <input
            matInput
            [formControl]="option.get('label')"
            placeholder="{{ 'FRONTEND.STORE.ORDER_FORM.OPTION' | translate }}"
          />
        </mat-form-field>
        <mat-form-field
          class="dropdown-option-value"
          *ngIf="option.get('useValue').value"
        >
          <input
            matInput
            [formControl]="option.get('value')"
            placeholder="{{ 'FRONTEND.STORE.ORDER_FORM.VALUE' | translate }}"
          />
        </mat-form-field>
        <a
          class="dropdown-option-value"
          (click)="option.get('useValue').setValue(true)"
          *ngIf="!option.get('useValue').value"
        >
          + {{ 'FRONTEND.STORE.ORDER_FORM.ASSIGN_VALUE' | translate }}
        </a>
        <button
          mat-icon-button
          type="button"
          color="primary"
          (click)="removeOption(i)"
        >
          <mat-icon
            attr.aria-label="{{
              'FRONTEND.STORE.ORDER_FORM.CLEAR_BUTTON' | translate
            }}"
          >
            clear
          </mat-icon>
        </button>
      </div>
    </div>
    <div class="order-form-mat-form-field">
      <a (click)="addOption()">
        + {{ 'FRONTEND.STORE.ORDER_FORM.OPTION' | translate }}
      </a>
    </div>
    <div class="dropdown-config">
      <mat-checkbox color="primary" [formControlName]="'allowMultiples'">
        {{ 'FRONTEND.STORE.ORDER_FORM.ALLOW_MULTIPLES' | translate }}
      </mat-checkbox>
      <ng-container *ngIf="orderFormFieldGroup.controls.allowMultiples.value">
        <mat-checkbox
          class="required-checkbox"
          color="primary"
          [formControlName]="'allowDuplicates'"
        >
          {{ 'FRONTEND.STORE.ORDER_FORM.ALLOW_DUPLICATES' | translate }}
        </mat-checkbox>
        <div>
          <mat-form-field class="order-form-mat-form-field">
            <input
              matInput
              formControlName="maxChoices"
              placeholder="{{
                'FRONTEND.STORE.ORDER_FORM.MAX_NUM_CHOICES' | translate
              }}"
              required
              type="number"
            />
            <mat-hint>
              {{
                'FRONTEND.STORE.ORDER_FORM.CHOICES_HINT'
                  | translate: { minChoices: 0 }
              }}
            </mat-hint>
            <mat-error *ngIf="'maxChoices.invalid'">
              {{
                'FRONTEND.STORE.ORDER_FORM.CHOICES_ERROR'
                  | translate: { minChoices: 0 }
              }}
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <div>
    <mat-form-field class="order-form-mat-form-field">
      <input
        matInput
        formControlName="labelControl"
        placeholder="Label"
        required
        novalidate
        (change)="createIdFromLabel()"
      />
      <mat-hint>
        {{
          'FRONTEND.STORE.ORDER_FORM.LABEL_HINT'
            | translate: { maxCharacters: 140 }
        }}
      </mat-hint>
      <mat-error *ngIf="'idControl.invalid'">
        {{ 'FRONTEND.STORE.ORDER_FORM.LABEL_ERROR' | translate }}
      </mat-error>
    </mat-form-field>
  </div>
  <!-- Prefix/suffix if textbox type is selected -->
  <ng-container
    *ngIf="
      getCurrentFieldInterface() && getCurrentFieldInterface() === 'textbox'
    "
  >
    <ng-container *ngIf="showSuffixes">
      <mat-form-field>
        <input matInput formControlName="prefixControl" placeholder="Prefix" />
      </mat-form-field>
      <mat-form-field>
        <input matInput formControlName="suffixControl" placeholder="Suffix" />
      </mat-form-field>
      <div class="show-hide-text-button">
        <a (click)="showSuffixes = !showSuffixes">
          {{ 'FRONTEND.STORE.ORDER_FORM.HIDE_PREFIX_SUFFIX' | translate }}
        </a>
      </div>
    </ng-container>
    <div *ngIf="!showSuffixes" class="show-hide-text-button">
      <a (click)="showSuffixes = !showSuffixes">
        + {{ 'FRONTEND.STORE.ORDER_FORM.PREFIX_SUFFIX' | translate }}
      </a>
      <div class="hidden-note">
        - {{ 'FRONTEND.STORE.ORDER_FORM.HIDDEN_NOTE' | translate }}
      </div>
    </div>
  </ng-container>

  <div>
    <mat-form-field class="order-form-mat-form-field">
      <input matInput formControlName="idControl" placeholder="ID" required />
      <mat-hint>{{ 'FRONTEND.STORE.ORDER_FORM.ID_HINT' | translate }}</mat-hint>
      <mat-error *ngIf="'idControl.invalid'">
        {{ 'FRONTEND.STORE.ORDER_FORM.ID_ERROR' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Upload url if file type is selected -->
  <ng-container
    *ngIf="getCurrentFieldInterface() && getCurrentFieldInterface() === 'file'"
  >
    <mat-form-field>
      <input
        matInput
        formControlName="uploadUrlControl"
        placeholder="{{ 'FRONTEND.STORE.ORDER_FORM.UPLOAD_URL' | translate }}"
      />
      <mat-hint>
        {{ 'FRONTEND.STORE.ORDER_FORM.UPLOAD_URL_HINT' | translate }}
      </mat-hint>
    </mat-form-field>
  </ng-container>

  <!-- Prefix/suffix if textbox type is selected -->
  <ng-container
    *ngIf="
      getCurrentFieldInterface() && getCurrentFieldInterface() === 'textbox'
    "
  >
    <!-- RegexValidator/RegexErrorMessage if textbox type is selected -->
    <ng-container *ngIf="showValidators">
      <mat-form-field>
        <input
          matInput
          formControlName="regexValidatorControl"
          placeholder="{{
            'FRONTEND.STORE.ORDER_FORM.REGEX_VALIDATOR' | translate
          }}"
        />
        <mat-error *ngIf="'regexValidatorControl.invalid'">
          {{ 'FRONTEND.STORE.ORDER_FORM.REGEX_VALIDATOR_ERROR' | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          formControlName="regexErrorMessageControl"
          placeholder="{{
            'FRONTEND.STORE.ORDER_FORM.REGEX_ERROR_MESSAGE' | translate
          }}"
        />
        <mat-hint>
          {{ 'FRONTEND.STORE.ORDER_FORM.REGEX_ERROR_MESSAGE_HINT' | translate }}
        </mat-hint>
      </mat-form-field>
      <div class="show-hide-text-button">
        <a (click)="showValidators = !showValidators">
          {{ 'FRONTEND.STORE.ORDER_FORM.HIDE_VALIDATION' | translate }}
        </a>
      </div>
    </ng-container>
    <div *ngIf="!showValidators" class="show-hide-text-button">
      <a (click)="showValidators = !showValidators">
        + {{ 'FRONTEND.STORE.ORDER_FORM.VALIDATION' | translate }}
      </a>
      <div class="hidden-note">
        - {{ 'FRONTEND.STORE.ORDER_FORM.HIDDEN_NOTE' | translate }}
      </div>
    </div>
  </ng-container>

  <!-- Optional description -->
  <div class="removable-form-field">
    <mat-form-field>
      <input
        matInput
        formControlName="descriptionControl"
        placeholder="{{ 'FRONTEND.STORE.ORDER_FORM.HINT_TEXT' | translate }}"
      />
      <mat-hint>
        {{ 'FRONTEND.STORE.ORDER_FORM.HINT_TEXT_HINT' | translate }}
      </mat-hint>
    </mat-form-field>
  </div>

  <div class="delete-field-section">
    <button
      mat-icon-button
      type="button"
      color="primary"
      (click)="removeField.emit()"
    >
      {{ 'FRONTEND.STORE.ORDER_FORM.DELETE_FIELD' | translate }}
      <!-- <mat-icon attr.aria-label="{{ 'FRONTEND.STORE.ORDER_FORM.CLEAR_BUTTON' | translate }}">clear</mat-icon> -->
    </button>
  </div>
</div>
